<template src="../templates/normal_fcont_43.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'

import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'

export default {
  name: 'app',
  data() {
    return {
      articleId: '43',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,
   FuncSearchGalleryQR,ReleaseDateForArticle,
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['43-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['43-2']}
    ]};
  }
};
</script>
<style />


